const DEFAULT_BORDER = "#D2D8DE";
const DEFAULT_TEXT = "#344054";
const DEFAULT_PLACEHOLDER = "#98A2B3";
const DEFAULT_ACCENT = "#9C4FFF";
const DEFAULT_FONT = "Be Vietnam Pro";

export const TOOLBAR_CONTROL_WIDTH_SX = {
  width: { xs: "100%", md: 324 },
  maxWidth: "100%",
};

function normalizeRadius(borderRadius) {
  return typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius;
}

export function createToolbarControlRootSx({
  height = 40,
  borderRadius = 8,
  backgroundColor = "#FFFFFF",
  outlineSx = { borderColor: DEFAULT_BORDER },
} = {}) {
  return {
    boxSizing: "border-box",
    height,
    backgroundColor,
    borderRadius: normalizeRadius(borderRadius),
    fontFamily: DEFAULT_FONT,
    "& .MuiOutlinedInput-notchedOutline": outlineSx,
    "&:hover .MuiOutlinedInput-notchedOutline": outlineSx,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      ...outlineSx,
      borderWidth: 1,
    },
    "&.Mui-disabled": {
      backgroundColor: "#F8FAFC",
    },
  };
}

export function createToolbarTextFieldSx({
  widthSx = TOOLBAR_CONTROL_WIDTH_SX,
  height = 40,
  borderRadius = 8,
  backgroundColor = "#FFFFFF",
  outlineSx = { borderColor: DEFAULT_BORDER },
  textColor = DEFAULT_TEXT,
  placeholderColor = DEFAULT_PLACEHOLDER,
  iconColor = DEFAULT_ACCENT,
  inputFontSize = 14,
  inputFontWeight = 400,
  inputPaddingY = "8px",
  inputRootPaddingLeft = "14px",
  inputRootPaddingRight = "24px",
} = {}) {
  return {
    ...(widthSx || {}),
    "& .MuiOutlinedInput-root": {
      ...createToolbarControlRootSx({
        height,
        borderRadius,
        backgroundColor,
        outlineSx,
      }),
      pl: inputRootPaddingLeft,
      pr: inputRootPaddingRight,
    },
    "& .MuiOutlinedInput-input": {
      padding: `${inputPaddingY} 0`,
      fontSize: inputFontSize,
      fontWeight: inputFontWeight,
      lineHeight: "24px",
      color: textColor,
      fontFamily: DEFAULT_FONT,
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: placeholderColor,
      opacity: 1,
    },
    "& .MuiInputAdornment-root": {
      mr: "10px",
      color: iconColor,
    },
  };
}

export function createToolbarSelectSx({
  height = 40,
  borderRadius = 8,
  backgroundColor = "#FFFFFF",
  outlineSx = { borderColor: DEFAULT_BORDER },
  textColor = DEFAULT_TEXT,
  iconColor = DEFAULT_ACCENT,
  textFontSize = 14,
  textFontWeight = 500,
  selectPadding = "8px 24px 8px 14px",
  iconRight = 14,
  iconFontSize = 20,
} = {}) {
  return {
    ...createToolbarControlRootSx({
      height,
      borderRadius,
      backgroundColor,
      outlineSx,
    }),
    "& .MuiSelect-select": {
      boxSizing: "border-box",
      minHeight: "unset",
      display: "flex",
      alignItems: "center",
      padding: `${selectPadding} !important`,
      fontSize: textFontSize,
      fontWeight: textFontWeight,
      color: textColor,
      fontFamily: DEFAULT_FONT,
    },
    "& .MuiSelect-icon": {
      right: iconRight,
      color: iconColor,
      fontSize: iconFontSize,
    },
  };
}

export const toolbarMenuItemSx = {
  fontSize: 14,
  fontFamily: DEFAULT_FONT,
};
